import React from 'react';
import com_1 from '../../assets/com_1.png';
import com_2 from '../../assets/com_2.png';
import com_3 from '../../assets/com_3.png';
import com_4 from '../../assets/com_4.png';
import com_5 from '../../assets/com_5.jpg';
import com_6 from '../../assets/com_6.png';

const FeaturedSection = () => {
  return (
    <div className="featured-wrapper">
      <div className="container-fluid">
        <ul className="ftrd-list">
          <li className="ftrd-hdr">Featured by: </li>
          <li className="ftrd-item">
            <a
              target="_blank"
              href="https://idealog.co.nz/venture/2018/05/idealog-bhives-race-space-meet-winners"
            >
              <img
                width="60%"
                src={com_1}
                alt="idealog logo"
                title="idealog logo"
              />
            </a>
          </li>
          <li className="ftrd-item">
            <img
              width="80%"
              src={com_2}
              alt="dominionpost logo"
              title="dominionpost logo"
            />
          </li>
          <li className="ftrd-item">
            <a
              target="_blank"
              href="https://www.nzherald.co.nz/business/news/article.cfm?c_id=3&objectid=11947182"
            >
              <img
                width="70%"
                src={com_3}
                alt="nzherald logo"
                title="nzherald logo"
              />
            </a>
          </li>
          <li className="ftrd-item">
            <a
              target="_blank"
              href="https://www.facebook.com/FeedMyFurbabyNZp/photos/a.1573624392674190/1810335265669767/?type=3&theater"
            >
              <img
                width="40%"
                src={com_4}
                alt="radiolive logo"
                title="radiolive logo"
              />
            </a>
          </li>
          <li className="ftrd-item">
            <a
              target="_blank"
              href="https://www.stuff.co.nz/business/103665879/the-homegrown-my-food-bag-version-for-your-pets-says-it-can-hold-out-against-amazons-effect"
            >
              <img
                width="50%"
                src={com_5}
                alt="stuff logo"
                title="stuff logo"
              />
            </a>
          </li>
          <li className="ftrd-item">
            <a
              target="_blank"
              href="https://www.youtube.com/watch?v=BETlJTSzq5s&t=180s"
            >
              <img
                src={com_6}
                alt="raceforspace logo"
                title="raceforspace logo"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FeaturedSection;
